// Pathify
import { make } from 'vuex-pathify'

const _ = require('lodash')

const endpoint = 'https://zzxfinu1af.execute-api.us-east-2.amazonaws.com'
const setIsBusy = 'setIsBusy'

const state = {
  displayAsSingular: 'Folder',
  displayAsPlural: 'Folders',
  folders: {
    data: [],
    originalData: [],
    isBusy: false,
    selected: [],
    selectedItem: { id: null, description: '' },
    empty: {
      id: null,
      folder_id: null,
      client_id: null,
      parent_id: '',
      estimator_id: null,
      description: null,
      note: '',
      updated: false,
      update_program: null,
      update_user_id: null,
    },
  },
}

const mutations = {
  ...make.mutations(state),

  setIsBusy: (state, isBusy) => {
    state.folders.isBusy = isBusy
  },

  setSelected: (state, payload) => {
    state.folders.selected = []
    state.folders.selectedItem = { ...payload }
  },

  push2Data: (state, dataFromDB) => {
    state.folders.data = []
    state.folders.data = dataFromDB

    // Get a copy of the original data, not a pointer to it
    state.folders.originalData = []
    for (const currentData of dataFromDB) {
      state.folders.originalData.push({ ...currentData })
    }

    state.folders.selected = []

    state.folders.isBusy = false
  },

  initializeTreeData: (state, planData) => {
    let foldersPlans

    for (const currentData of state.folders.data) {
      foldersPlans = []
      foldersPlans = planData.filter(plan => (plan.folder_id ? plan.folder_id.toString() : '') === currentData.folder_id.toString())
      currentData.children = foldersPlans
    }
  },

  successfulUpdate: (state) => {},
}

const actions = {
  ...make.actions(state),

  init: async () => {
    //
  },

  setEmpty: ({ commit, dispatch }) => {
    state.folders.selected = []
    state.folders.selectedItem = { id: null, description: '' }
    state.folders.data = []
  },

  setSelected: async ({ commit, dispatch }, payload) => {
    let selectedItem = { id: null, description: '' }

    if (payload) {
      selectedItem = payload
    }

    commit('setSelected', selectedItem)
  },

  retrieveAll: ({ commit, dispatch, rootGetters, rootState }) => {
    if (rootState.customer.customers.selectedItem.client_id.length > 0) {
      const thisAction = 'retrieveAllFolder'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'get',
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          let data2Push

          if (_.isEmpty(jsonResponse.error)) {
            data2Push = rootGetters['user/getEstimatorsData'](jsonResponse.data, rootState.user.users.default.estimator_id)
          } else {
            // toastColor = 'danger'
            // toastMessage = 'was not updated successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
            commit(setIsBusy, false)
          }

          return data2Push
        })
        .then(data2Push => {
          commit('push2Data', data2Push)
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  update: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'updateFolder'
    commit(setIsBusy, true)

    payload.folder_id = payload.id

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}`

    const options = {
      method: 'post',
      body: JSON.stringify(payload),
    }

    let toastColor = 'success'
    let toastMessage = 'updated successfully'

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          dispatch('retrieveAll')
        } else {
          toastColor = 'danger'
          toastMessage = 'was not updated successfully'
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
        }
      })
      .then(() => {
        console.info(`${state.displayAsSingular} Updated - '${payload.description}' ${toastMessage}, variant: ${toastColor}`)
        commit('successfulUpdate')
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  delete: ({ commit, dispatch, rootState }) => {
    if (state.folders.selected.length > 0) {
      const thisAction = 'deleteFolder'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'post',
        body: JSON.stringify(state.folders.selected),
      }

      let toastColor = 'success'
      let toastPrefix = ''
      let toastMessage = 'successfully removed'
      if (state.folders.selected.length > 1) {
        toastPrefix = `${state.folders.selected.length} ${state.displayAsPlural} were`
      } else {
        toastPrefix = `'${state.folders.selected[0].description}'`
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          if (_.isEmpty(jsonResponse.error)) {
            dispatch('retrieveAll')
          } else {
            toastColor = 'danger'
            toastMessage = 'was not deleted successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            commit(setIsBusy, false)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
          }
        })
        .then(() => {
          console.info(`${state.displayAsSingular} Deleted - ${toastPrefix} ${toastMessage}, variant: ${toastColor}`)
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  initializeTreeData: ({ commit, rootState }) => {
    commit('initializeTreeData', rootState.plan.plans.data)
  },
}

const getters = {
  createFolderId: () => (estimatorId) => {
    const d = new Date()
    const folderYear = d.getFullYear()
    const folderMonth = ('0' + (d.getMonth() + 1).toString()).slice(-2)
    return folderYear.toString() + '-' + folderMonth.toString() + '-' + estimatorId
  },

  createFolderDescription: () => (estimatorName) => {
    const d = new Date()
    const folderYear = d.getFullYear()
    const folderMonth = d.toLocaleString('default', { month: 'long' })
    return folderYear.toString() + ' ' + folderMonth.toString() + ': ' + estimatorName
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
